import React, { memo } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { usePeersStore } from '@src/stores';
import { createElementColor } from '@src/helpers';

import { BsMicMuteFill } from 'react-icons/bs';

import styles from '../videoBox.module.scss';

interface VoiceIndicatorProps {
  isMicMuted: boolean;
  wavyScale: number;
  top?: string;
  peerId?: string; // Make peerId optional to maintain backward compatibility
  isPipBox?: boolean;
}

const VoiceIndicator: React.FC<VoiceIndicatorProps> = ({ isMicMuted, wavyScale, peerId, top, isPipBox }) => {
  // Always call the hook, but only use the color if peerId is provided
  const peerColor = usePeersStore(useShallow((state) => (peerId ? state.getPeerColor(peerId) : null)));

  // Adjust the color for better contrast/visibility
  const backgroundColor = peerColor ? createElementColor(peerColor, 'voice-indicator') : null;

  // PIP mode styling for muted mic
  const pipMutedStyle = isPipBox
    ? {
        backgroundColor: '#093148',
      }
    : {};

  return isMicMuted ? (
    <div
      className={`${styles.voiceIndication} ${styles.micIcon}`}
      style={{
        ...(top?.length && { top }),
        ...pipMutedStyle,
      }}
    >
      <BsMicMuteFill size={16} color={isPipBox ? 'var(--color-danger, #DD5251)' : '#ffffff'} />
    </div>
  ) : (
    <div
      className={styles.voiceIndication}
      style={{ ...(backgroundColor && { backgroundColor }), ...(top?.length && { top }) }}
    >
      {[0.4, 0.6, 0.4].map((scale, index) => (
        <div
          key={`${index}-${scale}`}
          className={styles.voiceDot}
          style={{
            transform: `scaleY(${wavyScale === 1 ? wavyScale : wavyScale * scale})`,
            backgroundColor: '#ffffff',
          }}
        />
      ))}
    </div>
  );
};

export default memo(VoiceIndicator);
